import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _, {debounce} from 'lodash';
import {modifyPageLayoutComponents} from '../PageLayout';

import template from '../../templates/ProjectScope/ProjectScopeNew.rt';
import pageHeaderTemplate from '../../templates/ProjectScope/ProjectScopePageHeader.rt';
import projectScopeFooter from './ProjectScopeFooterNew';
import {errorBox_Show} from "../../actions/A_Popups";
import {AccessRights} from '../../schemas/accessRightsModel';
import PS from './ProjectScopeActionsNew';
import ProjectScopeSortableItems from "./ProjectScopeSortableItems";
import {postQtCategory} from "../NewScope/newScopeActions";
import {FEATURE_GROUP_ALL_NAME} from "../../constants/newScopeConstants";
import {arrayMove} from "../../utilities";

function mapStateToProps(state, ownProps) {
  const psState = state.projectScopeNew;
  const {featuresCreatorNew, auth, newScope} = state;
  const activeCategory = newScope.qtCategories[newScope.activeQtCategoryIndex];
  let activeCategoryId = 0
  if(activeCategory)
    activeCategoryId = activeCategory.id;

  const AR = AccessRights.get(state);

  let fgs = [];
  for (let key in psState.featuresGroups) {
    let fg = psState.featuresGroups[key];
    let idx = _.findIndex(psState.pendingChanges, (pc) => pc.groupName === fg.groupName);
    if (idx >= 0) {
      fgs[key] = psState.pendingChanges[idx];
    } else {
      fgs[key] = fg;
    }
  }
  const {qtCategories, activeQtCategoryIndex, featureGroupsSearchValue, qtCategoriesReceived, isWizardMode} = state.newScope;
  const {wizardList, wizardListReceived} = state.wizardState;

  return {
    term: psState.term,
    mode: psState.mode,
    featuresGroups: psState.featuresGroups,
    pendingChanges: psState.pendingChanges,
    updatedFeaturesGroups: fgs,
    showMode: (psState.hasKitchen == psState.hasBathroom) || AR.isSiteAdmin(false),
    qtCategories,
    activeQtCategoryIndex,
    featureGroupsSearchValue,
    qtCategoriesReceived,
    activeCategoryId,
    AR,
    isWizardMode,
    wizardList,
    wizardListReceived,
  };
}

// const debouncedSearchTerm = debounce((dispatch, ...args) => dispatch(PS.setSearchTerm(...args)), 300);

function mapDispatchToProps(dispatch) {

  return {
    // setSearchTerm: (...args) => debouncedSearchTerm(dispatch, ...args),
    setSearchTerm: PS.setSearchTerm,
    errorBox_Show: config => dispatch(errorBox_Show(config)),
    setMode: mode => dispatch(PS.setMode(mode)),
    loadFeaturesGroups: () => dispatch(PS.loadFeaturesGroups()),
    unloadFeatureGroups: () => dispatch(PS.unloadFeaturesGroups()),
    postQtCategory: (qtCategory, update) => dispatch(postQtCategory(qtCategory, update))
  };
}

class ProjectScopeNew extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      activeMode: 'All',
      reorderedFeatureGroups: []
    };
  }

  componentDidMount() {
    this.setReorderedFeatureGroups(this.props)
  }

  componentWillUnmount() {
    this.props.unloadFeatureGroups();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // if (this.props.term !== nextProps.term || this.props.mode !== nextProps.mode) {
    //   this.props.loadFeaturesGroups();
    // }

    if (this.props.newScope && (
      (nextProps.activeQtCategoryIndex !== this.props.activeQtCategoryIndex)
      || (_.size(nextProps.featuresGroups) !== _.size(this.props.featuresGroups))
      || (nextProps.featureGroupsSearchValue !== this.props.featureGroupsSearchValue)
      || (nextProps.qtCategories && nextProps.activeQtCategoryIndex
        && nextProps.qtCategories[nextProps.activeQtCategoryIndex]
        && (nextProps.qtCategories[nextProps.activeQtCategoryIndex].featureGroups.length
          !== this.state.reorderedFeatureGroups.length))
    )) {
      this.setReorderedFeatureGroups(nextProps)
    }
  }

  getFeatureCreatorLink = (groupName, newLink = false) => {
    return `features${newLink ? "-setup" : ""}?group=${encodeURIComponent(groupName)}&catId=${this.props.activeCategoryId || 0}`;
  }

  setReorderedFeatureGroups = (nextProps = this.props) => {
    this.setState({
      reorderedFeatureGroups: []
    }, () => {
      this.setState({
        reorderedFeatureGroups: this.getFeatureGroups(nextProps)
      })
    })
  };

  getFeatureGroups = (nextProps = this.props) => {
    if (!nextProps.newScope) {
      return nextProps.featuresGroups || []
    }
    // console.log("filteredFeatureGroups - before", nextProps.featureGroups);
    let filteredFeatureGroups = [];
    const currentActiveCategory = nextProps.qtCategories[nextProps.activeQtCategoryIndex];
    if (nextProps.featuresGroups && currentActiveCategory && currentActiveCategory.name !== FEATURE_GROUP_ALL_NAME) {
      currentActiveCategory.featureGroups
        .sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0) // sort by order
        .forEach((group) => {
          const existingGroup = nextProps.featuresGroups.find(featureGroup => featureGroup.groupName.toLowerCase() === group.groupName.toLowerCase());
          if (existingGroup) {
            filteredFeatureGroups.push(existingGroup)
          }
        });
    } else {
      filteredFeatureGroups = nextProps.featuresGroups || []
    }
    // console.log("filteredFeatureGroups - after", filteredFeatureGroups);
    if (nextProps.featureGroupsSearchValue) {
      const searchValue = nextProps.featureGroupsSearchValue.toLowerCase();
      return filteredFeatureGroups.filter(featureGroup => {
        return featureGroup.groupName.toLowerCase().includes(searchValue)
      })
    }

    return filteredFeatureGroups;
  }

  onSortStart = () => {
    window.draggingFeatureGroup = true;
  };

  onSortEnd = ({oldIndex, newIndex}, event) => {
    window.draggingFeatureGroup = false;

    const activeCategory = this.props.qtCategories[this.props.activeQtCategoryIndex];
    if (event.target.closest(".assign-sidebar-list__item")) { // dragged on the sidebar category
      const categoryIndex = +event.target.closest(".assign-sidebar-list__item").dataset.index;
      if (categoryIndex) { // index !== 0
        const currentFeatureGroup = this.state.reorderedFeatureGroups[oldIndex]; // {name: "Baseboard", features: [{…}, {…}, {…}], ...}
        const droppableCategory = this.props.qtCategories[categoryIndex]; // qtCategory
        if (droppableCategory.featureGroups.some(fGroup => fGroup.groupName === currentFeatureGroup.groupName)
        // && (droppableCategory.id !== activeCategory.id) // not the same category and featureGroup is missing
        ) {
          // featureGroup already exist
          this.props.errorBox_Show({
            title: 'Error',
            text: `Feature group ${currentFeatureGroup.groupName} already exists in the ${droppableCategory.name} category`,
            rightButtonText: 'OK',
            isRightButtonVisible: true
          });
        } else {
          const nextOrder = Math.max(...droppableCategory.featureGroups.map(fGroup => fGroup.order)) + 1;
          droppableCategory.featureGroups.push({
            groupName: currentFeatureGroup.groupName,
            order: nextOrder
          });
          this.props.postQtCategory(droppableCategory, true);
        }
      }
    } else if (this.props.activeQtCategoryIndex) { // sorting (if it is not All group)
      const filterGroups = this.getFeatureGroups(this.props);
      const reorderedFeatureGroups = arrayMove(filterGroups, oldIndex, newIndex);

      //1) update redux qtCategory & post in on the backend
      reorderedFeatureGroups.forEach((featureGroup, featureGroupIndex) => {
        const currentGroup = activeCategory.featureGroups.find(group => {
          return group.groupName && featureGroup.groupName && group.groupName.toLowerCase() === featureGroup.groupName.toLowerCase()
        });
        currentGroup.order = featureGroupIndex;
      });

      this.props.postQtCategory(activeCategory, true);

      //2) update redux qtCategory & post in on the backend
      this.setState({
        reorderedFeatureGroups: []
      }, () => {
        this.setState({
          reorderedFeatureGroups
        })
      });
    }
  }

  shouldCancelStart = (event) => {
    const excludedClassNames = ["pj-scope-icon-button", "pj-scope-eye-icon", "pj-scope-lir-title", "pj-scope-lir-description",
      "pj-scope-lir-enable-wrapper", "pj-scope-more-info-icon", "pj-scope-button-wrapper",
      "message-system-dismiss-button", "message-box-buttons", "pj-scope-lir-remove",
      "pj-scope-lir-icon-edit", "pj-scope-delete-icon", "pj-scope-new-icon-library", "pj-scope-new-icon-overlay",
      "pj-scope-lir-editing", "pj-scope-lir-switchers"];
    if (excludedClassNames.some(className => {
      return event.target.classList.contains(className) || event.target.closest("."+className)
    })) {
      return true
    }
  };

  removeFeatureGroupFromCategory = (featureGroup) => {
    const activeCategory = this.props.qtCategories[this.props.activeQtCategoryIndex];
    const featureGroupIndex = activeCategory.featureGroups.findIndex(fGroup => fGroup.groupName === featureGroup.groupName);
    const deletedOrder = activeCategory.featureGroups.find(fGroup => fGroup.groupName === featureGroup.groupName).order;

    activeCategory.featureGroups.splice(featureGroupIndex, 1); // delete featureGroup
    activeCategory.featureGroups = activeCategory.featureGroups.map(fGroup => {
      if (fGroup.order > deletedOrder) {
        fGroup.order--; // set order equal to order - 1
      }
      return fGroup
    });
    this.props.postQtCategory(activeCategory, true); // update BE && Frontend
  };

  render() {
    const {newScope, isWizardMode, wizardListReceived, qtCategoriesReceived} = this.props;
    if (newScope) {
      if (!qtCategoriesReceived || (isWizardMode && !wizardListReceived)) {
        return (
          <div className="ui-loader"/>
        )
      }
      return ProjectScopeSortableItems.call(this, this.props.activeQtCategoryIndex, this.removeFeatureGroupFromCategory, true)
    }
    return template.call(this)
  }
}

ProjectScopeNew.propTypes = {
  setSearchTerm: PropTypes.func.isRequired,
  loadFeaturesGroups: PropTypes.func.isRequired,
  featuresGroups: PropTypes.array,
  newScope: PropTypes.bool,
  qtCategories: PropTypes.array,
  activeQtCategoryIndex: PropTypes.number,
  postQtCategory: PropTypes.func
};

const ProjectScopePageHeader = pageHeaderTemplate;
const ProjectScopePageFooter = projectScopeFooter;

const connector = connect(mapStateToProps, mapDispatchToProps);
const ProjectScopeContainer = connector(ProjectScopeNew);
const ProjectScopePageHeaderContainer = connector(ProjectScopePageHeader);
const ProjectScopePageFooterContainer = connector(ProjectScopePageFooter);

export {
  ProjectScopeNew,
  ProjectScopeContainer,
  ProjectScopePageHeader,
  ProjectScopePageHeaderContainer,
  ProjectScopePageFooter,
  ProjectScopePageFooterContainer
};

export const ProjectScopeNewLayoutComponents = modifyPageLayoutComponents({
  pageHeader: ProjectScopePageHeaderContainer,
  content: ProjectScopeContainer,
  pageFooter: ProjectScopePageFooterContainer
});
